export default __webpack_public_path__ + "static/media/Faiyad_Ahmed_Resume.3125f9e1.pdf";